module.exports = __webpack_public_path__ + "static/media/sportse.2cef4788.webp";